import { render, staticRenderFns } from "./manualAllocation.vue?vue&type=template&id=8c7d5240&scoped=true"
import script from "./manualAllocation.vue?vue&type=script&lang=js"
export * from "./manualAllocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c7d5240",
  null
  
)

export default component.exports